module.exports = __webpack_public_path__ + "img/order-xj.28f0b246.png";